import { ActionRef, ScreenRef } from '../../App/types';
import { getDisplayRuleKey } from '../../ruleengine/display/getDisplayRuleKey';
import { DisplayRuleStateMap } from '.';

export const getDisplayRulesMetadata = (displayRules: DisplayRuleStateMap, screen: ScreenRef, action: ActionRef) => {
  const key = getDisplayRuleKey(screen, action);
  const displayRule = displayRules[key];
  return displayRule ? displayRule.currentMetadata || null : null;
};
